import React from "react";
import DataTable from "src/components/Table";
import { StyledTableCell } from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { ID, WashroomLogsSummaryForTable } from "src/types";

type WashroomLogsSummaryInput = {
  id: string;
  [key: string]: any;
};
import styled from "styled-components";

export interface WashroomLogsSummaryTableProps {
  isLoading: boolean;
  headers: string[];
  data: WashroomLogsSummaryInput[];
  onRowClick: (id: ID, name: string) => void;
}

export const WashroomLogsSummaryTable = ({ isLoading, headers, data, onRowClick }: WashroomLogsSummaryTableProps) => {
  const flattenedRows: Array<
    WashroomLogsSummaryForTable & {
      washroomKey: string;
      washroomLabel: string;
      clientName: string;
      locationName: string;
    }
  > = [];

  data?.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (key.includes("_") && typeof item[key] === "object") {
        const washroomId = key.split("_")[1];
        const washroomLabelKey = Object.keys(item?.washroomLabel).find((washroom: any) => {
          return item.washroomLabel[washroom].id === washroomId;
        });
        flattenedRows.push({
          ...item[key],
          id: item.id,
          washroomKey: washroomId,
          clientName: item.clientName,
          locationName: item.locationName,
          washroomLabel: washroomLabelKey !== undefined ? item.washroomLabel[washroomLabelKey].label : "N/A",
        });
      }
    });
  });

  return (
    <DataTable isLoading={isLoading} headers={headers}>
      <>
        {flattenedRows.map((row, idx) => (
          <TableRow onClick={() => onRowClick(row.id, row.washroomKey)} $clickable key={row.id + row.washroomKey + idx}>
            <StyledCell>{row.id}</StyledCell>
            <StyledCell>{row.clientName}</StyledCell>
            <StyledCell>{row.locationName}</StyledCell>
            <StyledCell>{row.washroomKey}</StyledCell>
            <StyledCell>{row.washroomLabel}</StyledCell>
            <StyledCell>{row.washroomCleaningInPercentage}</StyledCell>
          </TableRow>
        ))}
      </>
    </DataTable>
  );
};

const StyledCell = styled(StyledTableCell)`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
`;
